module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABsAAAAcCAYAAACQ0cTtAAAABHNCSVQICAgIfAhkiAAAAUdJREFUSEvtls1RwzAQhb/VgXNSAS5B7sCpADogJcDJyYncEp9IB7gDSiAdyCXQAaYBLyOF/BCCMxPFYQbQXftZz293nzB1GUaegB7dnJpG7xinpVC4F6CkYdENiwQjj1xoXygqpdEB43QDK9wE5P4k8NyuGRuYYQgkNEwwZOGl2x9wDLlwC/I0Wz1oG5aFeh7yu2BeQhNkLAmSyhVKfYx66zuCJbf9rzJu/5+pGyJyEwVaXR7ZQTssuJGahioKKMwZpfYwrFM37vbZWWFqXjESJ6M2c3KbHjbIssnjz96m3pVRuUYira9YRmnvLxvkrG78h7U1x7f77McmiJ/6nTT1rFII0z1ud7XPmgzVgeBhPmpJ5Dppgxl59qFqf7qKn4ifK3wkuDPDZq5GzAMi3YRU1QS0XIbUEL8pQS5PrV6op/qGcuvj9zvfB5cYHdi0sAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/case/case-nav-icon-04.png
// module id = vEV6
// module chunks = 1